import React from 'react';
import recordingOnSvg from 'src/images/recording-on.svg';
import recordingOnBlinkSvg from 'src/images/recording-on-blink.svg';
import recordingOnSmallSvg from 'src/images/recording-on-small.svg';
import recordingOnSmallBlinkSvg from 'src/images/recording-on-small-blink.svg';
import { BlinkingSvg } from './blinking-svg';

export interface RecordingIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | string;
  style?: React.CSSProperties;
  onClick?: () => void;
  pulsing?: boolean;
  small?: boolean;
  alt?: string;
}

export const RecordingIcon: React.FC<RecordingIconProps> = ({
  className = '',
  size = 'md',
  style,
  onClick,
  pulsing = false,
  small = false,
  alt = 'Recording',
}) => {
  const getSizeStyles = (sizeValue: string) => {
    switch (sizeValue) {
      case 'sm':
        return { width: '16px', height: 'auto' };
      case 'md':
        return { width: '24px', height: 'auto' };
      case 'lg':
        return { width: '32px', height: 'auto' };
      default:
        return { width: sizeValue, height: 'auto' };
    }
  };

  const combinedStyle = {
    ...getSizeStyles(size),
    ...style,
  };

  const pulsingClass = pulsing ? 'pulsing' : '';
  const combinedClassName = `recording-icon ${pulsingClass} ${className}`.trim();

  return (
    <BlinkingSvg
      src1={small ? recordingOnSmallSvg : recordingOnSvg}
      src2={small ? recordingOnSmallBlinkSvg : recordingOnBlinkSvg}
      alt={alt}
      className={combinedClassName}
      style={combinedStyle}
      onClick={onClick}
    />
  );
};
